import FieldEditor from "components/FieldEditor";
import { FieldError, PersonalSavings } from "types";
import * as fields from "pages/clientPortfolio/personalClient/personalClientAccounts/personalSavingsFieldDefinitions";
import AccountEditTemplate from "./AccountEditTemplate";
import { useEffect, useState } from "react";
import { requiredDateField } from "common/functions";
import { openConfirm } from "components/confirmBox";
export type Props = {
  account: PersonalSavings;
  isSaving: boolean;
  onCancel(): void;
  onSave(account: PersonalSavings): void;
};

function PersonalSavingsForm({ account, onCancel, onSave, isSaving }: Props) {
  const [state, setState] = useState<PersonalSavings>(account);
  const [errors, setErrors] = useState<FieldError[]>([]);

  useEffect(() => {
    errors.length > 0 && checkErrors();
  }, [state]);

  const commonProps = {
    state: state,
    errors,
    setState: (state: PersonalSavings) => {
      setState(state);
    },
  };

  function checkErrors() {
    if (!account) {
      return;
    }
    const errorsArray: FieldError[] = [
      ...requiredDateField(fields.personalSavingsOpenDate, state),
    ];

    if (
      state.closeDate &&
      state.openDate &&
      state.closeDate.toLowerCase() !== "invalid date" &&
      new Date(state.closeDate) < new Date(state.openDate)
    ) {
      let invalidCloseDateErr: FieldError = {
        id: `${fields.personalSavingsCloseDate.id}`,
        label: `${fields.personalSavingsCloseDate.label}`,
        error: "Close Date should be after the Open Date",
      };
      errorsArray.push(invalidCloseDateErr);
    }

    setErrors(errorsArray);
    return errorsArray;
  }

  function onSaveClick() {
    const err = checkErrors();
    if (err?.length === 0) {
      if (
        state.closeDate &&
        state.closeDate.toLowerCase() !== "invalid date" &&
        state.balance &&
        state.balance !== 0
      ) {
        openConfirm({
          title: "Error",
          description: `Account Balance should be $0.00 to close the account`,
          isAlert: true,
        });
      } else {
        onSave({
          ...state,
          isAccountClosed:
            state.closeDate && state.closeDate.toLowerCase() !== "invalid date"
              ? true
              : false,
        });
      }
    }
  }

  return (
    <AccountEditTemplate
      id={`PERSONAL_SAVINGS_${account.accountId}_form`}
      onSaveClick={onSaveClick}
      onCancelClick={onCancel}
      isSaving={isSaving}
      type="Savings"
      accountNumber={account.accountNumber || ""}
      balance={account.balance || 0}
      column1Fields={
        <>
          <FieldEditor<PersonalSavings>
            field={fields.personalSavingsOpenDate}
            {...commonProps}
          />
          <FieldEditor<PersonalSavings>
            field={fields.personalSavingsAccounNumber}
            {...commonProps}
          />
          <FieldEditor<PersonalSavings>
            field={fields.personalSavingsBalance}
            {...commonProps}
          />
        </>
      }
      column2Fields={
        <>
          <FieldEditor<PersonalSavings>
            field={fields.personalSavingsCloseDate}
            {...commonProps}
          />

          <FieldEditor<PersonalSavings>
            field={fields.personalSavingsType}
            {...commonProps}
          />
        </>
      }
    />
  );
}

export default PersonalSavingsForm;
